import React from 'react'

const SolutionGroup = React.lazy(() => import('pages/SolutionGroup/SolutionGroup'));
const SolutionGroupAdd = React.lazy(() => import('pages/SolutionGroup/SolutionGroupAdd'));
const SolutionGroupEdit = React.lazy(() => import('pages/SolutionGroup/SolutionGroupEdit'));
const SolutionGroupDetail = React.lazy(() => import('pages/SolutionGroup/SolutionGroupDetail'));

const SolutionGroupRoutes = [
    {
        path: '/solution-group',
        exact: true,
        name: 'Danh sách nhóm giải pháp',
        function: 'RS_SOLUTIONGROUP_VIEW',
        component: SolutionGroup,
    },
    {
        path: '/solution-group/add',
        exact: true,
        name: 'Thêm mới',
        function: 'RS_SOLUTIONGROUP_ADD',
        component: SolutionGroupAdd,
    },
    {
        path: '/solution-group/detail/:id',
        exact: true,
        name: 'Chi tiết',
        function: 'RS_SOLUTIONGROUP_VIEW',
        component: SolutionGroupDetail,
    },
    {
        path: '/solution-group/edit/:id',
        exact: true,
        name: 'Chỉnh sửa',
        function: 'RS_SOLUTIONGROUP_EDIT',
        component: SolutionGroupEdit,
    },
]

export default SolutionGroupRoutes
